import {FilterTypesEnum} from './advanced-filter-types.enum';

//#region INTERFACE IFilterType
/**
 * Interface for defining the structure of a filter type.
 * Used to describe the properties of a filter type, including its description, associated enum, input type, and symbol.
 */
export interface IFilterType {
  /**
   * A brief description of the filter type.
   * Describes what the filter type represents (e.g., 'equal to', 'greater than').
   *
   * @type {string}
   */
  description: string;

  /**
   * The filter type associated with the `FilterTypesEnum` enum.
   * Specifies the type of filter being applied, like `equalTo`, `greaterThan`, etc.
   *
   * @type {FilterTypesEnum}
   */
  enum: FilterTypesEnum;

  /**
   * Indicates whether the filter expects user input.
   * - 'single' means the filter takes one value for comparison.
   * - 'multiple' means the filter expects an array of values for comparison.
   * - 'none' means no value input is required (e.g. is empty / is not empty).
   *
   * @type {'single' | 'multiple' | 'none'}
   */
  inputs: 'single' | 'multiple' | 'none';

  /**
   * The symbol used to represent the filter in a query or condition.
   * Examples: '=', '>', '!=', etc.
   *
   * @type {string}
   */
  symbol: string;
}

//#endregion